export function addressIsPOBox(address) {
    const ADDRESS_PO_BOX_REGEX = /(p[.]?[o0][.]?|post\s*?office)\s*?box/gi;
    return ADDRESS_PO_BOX_REGEX.test(address)
}